import { db } from '../db';
import { FAMILY_SYNC_CONFIG } from '../config/family';

export type SyncConfig = { endpoint: string; token: string };

const KEYS = {
  lastSyncAt: 'sync.last-at'
} as const;

async function getSetting(key: string) {
  return (await db.settings.get(key))?.value ?? '';
}

async function setSetting(key: string, value: string) {
  if (value) await db.settings.put({ key, value });
  else await db.settings.delete(key);
}

export async function getSyncConfig(): Promise<SyncConfig> {
  return FAMILY_SYNC_CONFIG;
}

export async function getLastSyncAt() {
  return getSetting(KEYS.lastSyncAt);
}

export async function saveLastSyncAt(value: string) {
  await setSetting(KEYS.lastSyncAt, value);
}
